import { useState } from "react";
import { Link } from "react-router-dom";
import { Goal, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Empty, HS_BASE, PanelHead, card, focusRing, muted, pills, shortDate, withJob } from "./hsShared";

const tone = { high: pills.red, medium: pills.amber, low: pills.green };

export function HsActions({ actions, jobId, canClose, onChanged }) {
  const [busy, setBusy] = useState(null);
  const complete = async (item) => {
    setBusy(item.id);
    try {
      await api.patch(`/safety/${encodeURIComponent(item.record_id)}/corrective-actions/${encodeURIComponent(item.id)}`, { revision: item.revision, status: "completed" });
      toast.success("Action marked complete — awaiting verification");
      onChanged();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not update the action. Refresh and try again.");
      if (e.response?.status === 409) onChanged();
    } finally { setBusy(null); }
  };
  return <article className={`${card} min-w-0 p-[18px]`} data-testid="hs-actions-panel">
    <PanelHead icon={Goal} title="H&S Actions" link={withJob(`${HS_BASE}/hazards?actions=open`, jobId)} linkLabel="View all actions" testId="hs-actions-view-all" />
    {!actions.items.length ? <Empty testId="hs-actions-empty">No outstanding corrective actions{jobId ? " for this job" : ""}.</Empty> :
      <ul className="divide-y divide-[#e0e6ef] dark:divide-white/10">
        {actions.items.map(item => <li key={item.id} className="flex items-center gap-3 py-2.5 text-xs" data-testid={`hs-action-${item.id}`}>
          {busy === item.id ? <Loader2 className="h-4 w-4 shrink-0 animate-spin text-[#FF5F15]" /> :
            <input type="checkbox" disabled={!canClose || !!busy} checked={false} onChange={() => complete(item)} data-testid={`hs-action-complete-${item.id}`}
              aria-label={`Mark "${item.title}" complete`} title={canClose ? "Mark complete (office verification still required)" : "Only office users can complete actions here"}
              className={`h-4 w-4 shrink-0 cursor-pointer accent-[#FF5F15] disabled:cursor-not-allowed ${focusRing}`} />}
          <Link to={item.href} className={`min-w-0 flex-1 rounded hover:text-[#e6471a] ${focusRing}`}>
            <span className="block truncate font-semibold">{item.title}{item.job_label ? ` – ${item.job_label}` : ""}</span>
            <span className={`block truncate text-[11px] ${muted}`}>{item.assigned_name ? `${item.assigned_name} · ` : ""}{item.status === "in_progress" ? "In progress" : "Open"}</span>
          </Link>
          <span className={`shrink-0 rounded-full px-2.5 py-1 text-[11px] font-bold capitalize ${tone[item.priority]}`}>{item.priority}</span>
          <span className={`w-[74px] shrink-0 text-right ${item.overdue ? "font-bold text-[#d61b2b]" : muted}`}>{item.due_date ? `Due ${shortDate(item.due_date)}` : "No due date"}</span>
        </li>)}
      </ul>}
    {actions.open > actions.items.length && <p className={`mt-2 text-[11px] ${muted}`}>Showing {actions.items.length} of {actions.open} outstanding · priority follows the source record's severity.</p>}
  </article>;
}
